'use client';
import React, { useState } from 'react';

export default function SubscribeSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    interest: 'Cosmology',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section id="subscribe" className="bg-[#0d1120] py-14 border-b border-[#1e2a3a]">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <h2
            className="text-white font-bold mb-3"
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: 'clamp(24px, 3vw, 36px)',
              lineHeight: '1.2',
            }}
          >
            Stay at the{' '}
            <span style={{ color: '#e01a2e' }}>Inception</span>
            {' '}of Knowledge
          </h2>
          <p
            className="text-[#a0aec0] text-[15px] leading-relaxed"
            style={{ fontFamily: 'Roboto, sans-serif' }}
          >
            Get the latest theories, stories, and deep-dives delivered to your inbox.
            <span className="text-white font-medium"> Join over 12,000 curious minds</span> exploring
            the origins of everything.
          </p>
        </div>

        {submitted ? (
          <div className="max-w-md mx-auto text-center py-10">
            <div className="w-16 h-16 rounded-full bg-[#e01a2e]/10 border border-[#e01a2e]/30 flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-[#e01a2e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3
              className="text-white font-bold text-xl mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              You&apos;re In!
            </h3>
            <p className="text-[#a0aec0] text-[14px]" style={{ fontFamily: 'Roboto, sans-serif' }}>
              Welcome to The Inceptions. Your first deep-dive is on its way.
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="max-w-2xl mx-auto bg-[#111827] border border-[#1e2a3a] rounded-sm p-8"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
              <div>
                <label
                  className="block text-[#a0aec0] text-[12px] font-semibold mb-1.5 uppercase tracking-wider"
                  style={{ fontFamily: 'Roboto, sans-serif' }}
                >
                  Full Name
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Your name"
                  required
                  className="w-full bg-[#0d1120] border border-[#2d3748] text-white text-[14px] px-4 py-2.5 rounded-sm outline-none focus:border-[#e01a2e] transition-colors placeholder-[#4a5568]"
                  style={{ fontFamily: 'Roboto, sans-serif' }}
                />
              </div>
              <div>
                <label
                  className="block text-[#a0aec0] text-[12px] font-semibold mb-1.5 uppercase tracking-wider"
                  style={{ fontFamily: 'Roboto, sans-serif' }}
                >
                  Email
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="your@email.com"
                  required
                  className="w-full bg-[#0d1120] border border-[#2d3748] text-white text-[14px] px-4 py-2.5 rounded-sm outline-none focus:border-[#e01a2e] transition-colors placeholder-[#4a5568]"
                  style={{ fontFamily: 'Roboto, sans-serif' }}
                />
              </div>
            </div>
            <div className="mb-6">
              <label
                className="block text-[#a0aec0] text-[12px] font-semibold mb-1.5 uppercase tracking-wider"
                style={{ fontFamily: 'Roboto, sans-serif' }}
              >
                Primary Interest
              </label>
              <select
                value={formData.interest}
                onChange={(e) => setFormData({ ...formData, interest: e.target.value })}
                className="w-full bg-[#0d1120] border border-[#2d3748] text-[#a0aec0] text-[14px] px-4 py-2.5 rounded-sm outline-none focus:border-[#e01a2e] transition-colors"
                style={{ fontFamily: 'Roboto, sans-serif' }}
              >
                <option>Cosmology</option>
                <option>Biology</option>
                <option>Physics</option>
                <option>Philosophy</option>
                <option>Chemistry</option>
                <option>Civilization</option>
                <option>Mathematics</option>
                <option>Evolution</option>
                <option>Technology</option>
                <option>Neuroscience</option>
                <option>Astronomy</option>
                <option>All Topics</option>
              </select>
            </div>
            <div className="flex items-start gap-3 mb-6">
              <input
                type="checkbox"
                id="consent"
                required
                className="mt-0.5 accent-[#e01a2e] w-4 h-4 flex-shrink-0"
              />
              <label
                htmlFor="consent"
                className="text-[#a0aec0] text-[12px] leading-relaxed cursor-pointer"
                style={{ fontFamily: 'Roboto, sans-serif' }}
              >
                Yes, I&apos;d like to receive the Inceptions newsletter with articles, theories, and
                stories about the origins of everything. I can unsubscribe at any time.
              </label>
            </div>
            <div className="text-right">
              <button
                type="submit"
                className="inline-flex items-center gap-2 bg-[#e01a2e] hover:bg-[#c0152a] text-white font-semibold text-[14px] px-8 py-3 rounded-[3px] transition-all duration-200"
                style={{ fontFamily: 'Roboto, sans-serif' }}
              >
                Subscribe Free
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
}
